export function formatPriceDelta(
  price?: number,
  cultureCurrency: string = 'USD',
  locale: string = 'en-US'
): string {
  if (typeof price === 'number' && price !== 0) {
    const formattedPrice = formatCurrency(price, cultureCurrency, locale)
    return ` (+${formattedPrice})`
  }
  return ''
}

export function checkIfNotNull(value: any): boolean {
  return value !== undefined && value !== null
}

function formatCurrency(value: any, cultureCurrency: string, locale: string = 'en-US'): string {
  if (cultureCurrency === 'GHS') {
    const defaultFormatter = Intl.NumberFormat('en-AU', { minimumFractionDigits: 2 })
    return defaultFormatter.format(value)
  }

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: cultureCurrency,
    }).format(value)
  } catch (ex) {
    const defaultFormatter = Intl.NumberFormat('en-AU', { minimumFractionDigits: 2 })
    return defaultFormatter.format(value)
  }
}
